export function NoAiIcon({
  className,
  strikethrough = true,
}: {
  className?: string;
  strikethrough?: boolean;
}) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Brain outline - left hemisphere */}
      <path
        d="M7.5 2.5C7.5 2.5 6 1 4.5 1.5C3 2 2.5 3.5 2.5 4.5C1.5 5 1 6 1 7C1 8 1.5 9 2.5 9.5C2.5 10.5 3 12 4.5 12.5C5.5 13 7 12.5 7.5 12"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Brain outline - right hemisphere */}
      <path
        d="M7.5 2.5C7.5 2.5 9 1 10.5 1.5C12 2 12.5 3.5 12.5 4.5C13.5 5 14 6 14 7C14 8 13.5 9 12.5 9.5C12.5 10.5 12 12 10.5 12.5C9.5 13 8 12.5 7.5 12"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Brain center line */}
      <path
        d="M7.5 2.5V12"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      {/* Brain folds */}
      <path
        d="M4.5 5.5H7.5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M7.5 8.5H10.5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      {/* Diagonal strike-through line */}
      {strikethrough && (
        <path
          d="M1 1L14 14"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}
